// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"070057fa","343":"070057fa","349":"5706bf1c","376":"98d9062c","658":"78b116be","689":"ec93b074","888":"85b34741"}[chunkId] + ".chunk.css";
};